import React from "react";
import Bg from "../../assets/images/Lp/hero-bg.jpg";
import "./Hero.css";

const Box_data = [
  {
    id: 1,

    title: "1%",
    desc: "Average % of orders from people making multiple email addresses (i.e., fraudulent orders)",
  },
  {
    id: 2,

    title: "11x",
    desc: "$ of Discounts saved vs. monthly cost of CustomerGenius",
  },
  {
    id: 3,

    title: "38%",
    desc: "Percentage of fraud-attempting customers who repurchased at full price once caught",
  },
  {
    id: 4,

    title: "2x",
    desc: "Average profit from returning fraudulent customers vs. monthly cost of CustomerGenius",
  },
];

export default function Hero({ id }) {
  return (
    <div id={id} className=" section">
      <div
        className="hero-inner"
        style={{
          backgroundImage: `url(${Bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div class="container">
          <div className="content-col center">
            <h1 className="h1 title">
              Stop Losing Money from Discount Abuse on Shopify
            </h1>
            <a
              href="https://apps.shopify.com/customergenius"
              className="button button--secondary bottom"
            >
              Start Catching Abusers Today with a 14 Day Free Trial!
            </a>
          </div>

          <div className="flex flex-row hero-bottom">
            <div class="grid md:grid-cols-4 gtid-cols-1 gap-8">
              {Box_data.map((item) => {
                return (
                  <div className="flex flex-col hero-box" key={item.id}>
                    <div className=" flex items-center gap-6">
                      <div className="text-[#fff] text-5xl font-bold number">
                        {item.title}
                      </div>
                      <div className="text-[#fff] text-sm font-normal">
                        {item.desc}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
